

import { Component, Vue, Prop } from 'vue-property-decorator';
import { PopupModule } from '~common-store/modules/popup';

@Component
export default class ContentFilter extends Vue {
    @Prop({ default: '' }) readonly filterPlaceholder!: string;

    get filterValue() {
        return PopupModule.filterValue;
    }
    set filterValue(val: string) {
        PopupModule.setFilterValue(val || '');
    }

    get filterIncludesValue() {
        return PopupModule.filterIncludesValue;
    }
    set filterIncludesValue(val: boolean) {
        PopupModule.setFilterIncludesValue(val);
    }
}
